import PropTypes from 'prop-types';
import React, { Component, PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import moment from 'moment';
import Icon from '@ontruck/ontruck-react-components/lib/Icon';

import style from './style.module.scss';

import { Table, TableBody, TableRow, TableCell } from 'components/Table';
import { FormatInteger } from 'utils/format';

import { palletsByCountry } from 'utils/journey';

const vanImage = () => <Icon name="van" className={style.vehicleIcon} />;
const boxVanImage = () => <Icon name="box-van" className={style.vehicleIcon} />;
const rigidTruckImage = () => <Icon name="rigid" className={style.vehicleIcon} />;
const semiTrailerImage = () => <Icon name="semi-trailer" className={style.vehicleIcon} />;
const fullTrailerImage = () => <Icon name="semi-trailer" className={style.vehicleIcon} />;
const tractorImage = () => <Icon name="tractor" className={style.vehicleIcon} />;

const VEHICLE_IMAGES = {
  van: vanImage,
  rigid_truck: rigidTruckImage,
  semi_trailer: semiTrailerImage,
  full_trailer: fullTrailerImage,
  box_van: boxVanImage,
  tractor_unit: tractorImage,
};

const VehicleImage = ({ type }) =>
  VEHICLE_IMAGES[type] ? <span title={type}>{VEHICLE_IMAGES[type]()}</span> : null;

VehicleImage.propTypes = {
  type: PropTypes.string,
};

const ExtraIcon = ({ name }) => <Icon name={name} className={style.extraIcon} />;

ExtraIcon.propTypes = {
  name: PropTypes.string,
};

const HeightIcon = () => <span className={style.heightIcon} />;
const WidthIcon = () => <span className={style.widthIcon} />;

class ContractItemContainer extends PureComponent {
  static propTypes = {
    onRowClick: PropTypes.func,
    contract: PropTypes.object,
    intl: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.onRowClick = this.onRowClick.bind(this);
  }

  onRowClick() {
    const { contract, onRowClick } = this.props;
    onRowClick(contract.id);
  }

  render() {
    const { contract, intl } = this.props;

    const vehicle = contract.vehicle;
    const driver = contract.driver;

    const t = intl.messages.components.ContractList;
    const dateFormats = intl.messages.date_formats;
    const pallet_type =
      (contract && contract.carrier && palletsByCountry[contract.carrier.country]) ||
      palletsByCountry.default;
    return (
      <TableRow onRowClick={this.onRowClick}>
        <TableCell fit className={style.vehicleCell}>
          <VehicleImage type={vehicle.vehicle_type} />
          {vehicle.container_length && vehicle.container_length > 0 ? (
            <span className={style.smallDetail}>
              {vehicle.container_length} {t.meters}
            </span>
          ) : null}
        </TableCell>
        <TableCell light fit className={style.monospace}>
          {vehicle.plate_number}
        </TableCell>
        <TableCell fit number bold className={style.rightCell}>
          {vehicle.max_pallets ? `${vehicle.max_pallets} ${t[pallet_type]}` : null}
        </TableCell>
        <TableCell fit number className={style.rightCell}>
          {vehicle.max_weight && vehicle.max_weight > 0 ? (
            <span>
              <FormatInteger value={vehicle.max_weight} />
              &nbsp;
              {t.kg}
            </span>
          ) : null}
        </TableCell>
        <TableCell number fit>
          {vehicle.container_height && vehicle.container_height > 0 ? (
            <span className={style.cellRelative}>
              <HeightIcon /> {vehicle.container_height} {t.meters}
            </span>
          ) : null}
        </TableCell>
        <TableCell number fit>
          {vehicle.container_width && vehicle.container_width > 0 ? (
            <span className={style.cellRelative}>
              {vehicle.container_width} {t.meters}
              <WidthIcon />
            </span>
          ) : null}
        </TableCell>
        <TableCell fit>{vehicle.has_liftgate ? <ExtraIcon name="lift-truck" /> : null}</TableCell>
        <TableCell fit>
          {vehicle.has_lateral_loading ? <ExtraIcon name="side-door" /> : null}
        </TableCell>
        <TableCell>{/*growth cell*/}</TableCell>
        <TableCell fit bold>
          {driver.contact_name}
        </TableCell>
        <TableCell light fit>
          {moment(contract.start_date).format(dateFormats.day_number_month_full)} -{' '}
          {contract.end_date
            ? moment(contract.end_date).format(dateFormats.day_number_month_full)
            : t.undefined}
        </TableCell>
      </TableRow>
    );
  }
}

const ContractItem = injectIntl(ContractItemContainer);

const NO_OP = () => {
  /*noop*/
};

class ContractListContainer extends Component {
  render() {
    const { contracts, onRowClick = NO_OP } = this.props;

    return (
      <div>
        <Table>
          <TableBody>
            {contracts.map((contract, key) => (
              <ContractItem key={key} contract={contract} onRowClick={onRowClick} />
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }
}

ContractListContainer.propTypes = {
  contracts: PropTypes.array,
  onRowClick: PropTypes.func,
};

ContractListContainer.defaultProps = {
  showSummary: true,
};

export default injectIntl(ContractListContainer);
